import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-09646bd8")

_pushScopeId("data-v-09646bd8")
const _hoisted_1 = { class: "t-center" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Get bounds for deposit $50")
const _hoisted_3 = { class: "d-f mt-20 px-20" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Make single deposit of $50 to get a $10 coupon")
const _hoisted_5 = { class: "t-center" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Deposit")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")
  const _component_t = _resolveComponent("t")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Pic, {
        type: "svg",
        src: "home/dollar",
        width: "56",
        height: "56"
      }),
      _createVNode(_component_t, {
        as: "p",
        path: "home_16",
        class: "mt-20 f-xxl f-bold"
      }, {
        default: _withId(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_t, {
        as: "p",
        path: "home_17"
      }, {
        default: _withId(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_Pic, {
        src: "home/coupon$5",
        width: "80",
        height: "56",
        class: "ml-16"
      })
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_router_link, {
        to: "/in",
        custom: ""
      }, {
        default: _withId(({navigate}) => [
          _createVNode("button", {
            class: "recharge mt-16 f-bold br-lg",
            onClick: navigate
          }, [
            _createVNode(_component_t, { path: "home_38" }, {
              default: _withId(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ], 8, ["onClick"])
        ]),
        _: 1
      })
    ])
  ]))
})